const state = {
  navHeight: ''
}
const mutations = {
  SET_NAV_HEIGHT(state, navHeight) {
    state.navHeight = navHeight
  }
}
const actions = {
  // 设置导航高度
  setNavHeight({ commit }, navHeight) {
    commit('SET_NAV_HEIGHT', navHeight)
  }
}
export default {
  state,
  mutations,
  actions
}
